<template>
    <div>
        
        <el-dialog title="微信扫码" :visible.sync="dialogVisible" width="50%" center 
        :close-on-click-moda="false" 
        @close="closeDialog">
            <div style="display: flex;justify-content: center;">
                <div style="width: 260px;  height: 260px;  border: 1px solid #c9c5c5; text-align: center;    display: flex;
            align-items: center;justify-content: center;">

                <div ref="qrCodeUrl"></div>
                <!-- 中间的logo，通过position:absolute;定位到中间 -->
                <img class="qrcode-logo" width="55" src="@/assets/img/scanlogo.png" alt="华万">

                <div class="qrcode_login_rl_bg" id="qrcode_login_timeout_tips"  v-show="isTimeout" >
                    <div class="qrcode_login_rl_mask"></div>
                    <div class="qrcode_login_rl_info">
                    <i class="ww_commonImg ww_commonImg_Alert"></i>
                    <div class="qrcode_login_rl_label"> 
                        二维码已过期 
                        <el-button type="text" @click="qrCodeGeneration">刷新</el-button>
                    </div>
                    </div>
                </div>


                </div>

            </div>

            <div class="bdwxsm">
                <p>关注后可扫码登录</p>

            </div>
        </el-dialog>

    </div>
</template>

<script>
import QRCode from 'qrcodejs2'

//API
import { scan, checkscan} from '../../api/userMG'
// 导出模块
export default {
  // 模块数据
  data() {
    //数据  
    return {
      isTimeout: false, //二维码状态
      ticket: '',
      timer: null,
      visible: false,
      dialogVisible: false,
    };
  },
  
  props: {
    visibleC: Boolean,
    userid: Number
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {
    'visibleC':{
        handler(val1,val2){
            this.dialogVisible = val1
            if(this.dialogVisible){
                this.qrCodeGeneration()
            }else{
                this.closeScan()
            }
        },
        deep: true,
        immediate:true
    }
  },
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    // 二维码生成
    qrCodeGeneration() {
        this.isTimeout = false
        // 二维码弹框显示
        if(this.$refs.qrCodeUrl){
          this.$refs.qrCodeUrl.innerHTML = ""
        }
        // 生成二维码
        scan({action:'bind', "userId": this.userid}).then(res=>{
          var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: res.url, // 需要转换为二维码的内容
                width: 230,
                height: 230,
                // render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                colorDark: "#000000", //二维码颜色
                colorLight: "#ffffff", //二维码背景色
                correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
          });
          
          this.ticket = res.ticket
          this.setTimer();//开启定时任务
          
        })
    },
    /**定时器*/
    setTimer() {
      this.timer = setInterval(() => {
        this.checkQrCode();
      }, 2000);
    },
    checkQrCode() {
      let that = this;
      if(!this.ticket){
        return;
      }
      checkscan({"ticket": this.ticket}).then(res=>{
        if(res==1){
          clearInterval(that.timer);//扫码成功后清空定时器
          that.$message.success('扫码成功')
          that.closeDialog()
        }else if(res==-1){
          clearInterval(that.timer);//扫码超时后清空定时器
					that.isTimeout = true;//出现刷新的遮罩
        }else if(res==1009){
          // clearInterval(that.timer);//扫码超时后清空定时器
          that.$message.warning('该微信已绑定其他账号')
        }
      })
    },
    closeScan(){
      clearInterval(this.timer);//扫码超时后清空定时器
    },
    closeDialog() {
      this.closeScan()
      this.$emit('closeDialog',{bind:true})
    },


  },
  // 创建前状态(里面是操作)
  beforeCreate() {},
  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载前状态(里面是操作)
  beforeMount() {},
  // 挂载结束状态(里面是操作)
  mounted() {},
  // 更新前状态(里面是操作)
  beforeUpdate() {},
  // 更新完成状态(里面是操作)
  updated() {},
  // 销毁前状态(里面是操作)
  beforeDestroy() {},
  // 销毁完成状态(里面是操作)
  destroyed() {}
};
</script>
// scoped 样式只在本组件使用
<style scoped>

.qrcode_login_rl_bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.qrcode_login_rl_mask {
    width: 260px;
    height: 260px;
    position: absolute;
    top: 55px;
    left: 52%;
    margin-left: -143px;
    background: rgba(255, 255, 255, .9);
}
.qrcode_login_rl_info {
    position: absolute;
    top: 163px;
    width: 100%;
    text-align: center;
    z-index: 2;
    font-size: 14px;
}

.bdwxsm {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  margin-top: 20px;
}

.qrcode-logo {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 55px;
}

</style>



// WEBPACK FOOTER //
// src/components/scan/wxscan.vue